import React from 'react';
import { Layout, Button, Menu, List, Card } from 'antd'; // Ant Design components
const { Header, Sider, Content, Footer } = Layout;

const AppFooter = () => (
  <Footer style={{ textAlign: 'center', marginTop: '0px', backgroundColor: '#000000' }}>
  </Footer>
);

export default AppFooter;
